import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

const RATIO_LEFT = 0.33;
const RATIO_RIGHT = 0.66;

class CarouselBehavior extends React.Component {
  static propTypes = {
    onNext: PropTypes.func.isRequired,
    onPrev: PropTypes.func.isRequired,
    cursorStore: PropTypes.object.isRequired,
    infinite: PropTypes.bool,
    currentIndex: PropTypes.number,
    itemsLength: PropTypes.number,
  };

  componentDidMount() {
    this.domNode = ReactDOM.findDOMNode(this); // eslint-disable-line
    this.updateValues();

    window.addEventListener('resize', this.resizeHandler);
    this.domNode.addEventListener('mouseleave', this.mouseLeaveHandler);
    this.domNode.addEventListener('mousemove', this.mouseMoveHandler);
    this.domNode.addEventListener('click', this.clickHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
    this.domNode.removeEventListener('mouseleave', this.mouseLeaveHandler);
    this.domNode.removeEventListener('mousemove', this.mouseMoveHandler);
    this.domNode.removeEventListener('click', this.clickHandler);
  }

  resizeHandler = debounce(() => {
    this.updateValues();
  }, 200);

  mouseLeaveHandler = () => {
    this.props.cursorStore.setNone();
  };

  calculateMousePositionRatio = x => x / this.windowWidth;

  mouseMoveHandler = e => {
    const ratio = this.calculateMousePositionRatio(e.clientX);
    const { currentIndex, infinite, itemsLength } = this.props;

    switch (true) {
      case (infinite || currentIndex > 0) && ratio < RATIO_LEFT:
        this.props.cursorStore.setPrev();
        break;
      case (infinite || currentIndex < itemsLength - 1) && ratio > RATIO_RIGHT:
        this.props.cursorStore.setNext();
        break;
      default:
        this.props.cursorStore.setNone();
    }
  };

  clickHandler = e => {
    const { currentIndex, itemsLength } = this.props;
    const ratio = this.calculateMousePositionRatio(e.clientX);

    switch (true) {
      case ratio < RATIO_LEFT:
        if (currentIndex === 1) {
          this.props.cursorStore.setNone();
        }
        this.props.onPrev();
        break;
      case ratio > RATIO_RIGHT:
        if (currentIndex === itemsLength - 2) {
          this.props.cursorStore.setNone();
        }
        this.props.onNext();
        break;
    }
  };

  updateValues() {
    this.windowWidth = window.innerWidth;
  }

  render() {
    return this.props.children;
  }
}

export default inject(stores => ({ cursorStore: stores.store.cursorStore }))(observer(CarouselBehavior));



// WEBPACK FOOTER //
// ./src/components/CarouselBehavior.js